const defaultRender = (value) => (value ? value : "--");

const dueFilter = [
  { text: "Yes", value: true },
  { text: "No", value: false },
];

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    render: defaultRender,
  },
  {
    title: "Email",
    dataIndex: "email",
    render: defaultRender,
  },
  {
    title: "Submit",
    dataIndex: "submit",
    render: defaultRender,
  },
  {
    title: "Assigned To",
    dataIndex: "assignTo",
    render: defaultRender,
    onFilter: (value, record) => {
      return record?.employee_id === value;
    },
    width: 200,
  },
  {
    title: "Received Date",
    dataIndex: "startDate",
    render: defaultRender,
  },
  {
    title: "Due",
    dataIndex: "due",
    render: defaultRender,
    filters: dueFilter,
    onFilter: (value, record) => record?.is_due === value,
  },
  {
    title: "Due Date",
    dataIndex: "dueDate",
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: defaultRender,
    fixed: "right",
  },
  {
    title: "Action",
    dataIndex: "action",
    render: defaultRender,
  },
];

export default columns;
